<template>
  <div>
    <!-- todos los proyectos -->
    <swiper
      class="swiper-container"
      :modules="modules"
      :slides-per-view="slide"
      :space-between="50"
      :pagination="{ clickable: true }"
      v-if="props.isHome == true">
      <!-- para logueados con curso -->
      <swiper-slide class="slide card-proyectos curso" v-if="curso">
        <div class="">
          <img
            class="contenedor-proyecto_imagen_card"
            :src="curso.imagen"
            :alt="curso.nombre" />
        </div>
        <div class="card-proyecto__texto">
          <h3 class="s-center titulo">{{ curso.titulo }}</h3>
          <p class="s-center area">{{ curso.area }} {{ curso.subArea }}</p>
          <div
            v-html="curso.proyecto"
            class="proyecto__descripcion s-left"></div>
        </div>
        <!-- botones -->
        <div class="s-center">
          <Button
            class="boton-primario"
            label="Proyecto del curso"
            v-on:click.prevent="requerimientoProyecto(curso.id)" />
        </div>
      </swiper-slide>
      <!-- para logueados sin curso -->
      <swiper-slide
        v-for="proyecto in mostrarAreaProyectos"
        :key="proyecto.titulo"
        class="slide card-proyectos">
        <div class="">
          <img
            class="contenedor-proyecto_imagen_card"
            :src="proyecto.imagen"
            :alt="proyecto.nombre" />
        </div>
        <div class="card-proyecto__texto">
          <h3 class="s-center titulo">{{ proyecto.titulo }}</h3>
          <p class="s-center area">
            {{ proyecto.area }} {{ proyecto.subArea }}
          </p>
          <div
            v-html="proyecto.proyecto"
            class="proyecto__descripcion s-left"></div>
        </div>
        <!-- botones -->
        <div class="s-center">
          <Button
            class="boton-primario"
            label="Ver proyecto"
            v-on:click.prevent="requerimientoProyecto(proyecto.id)" />
        </div>
      </swiper-slide>

      ...
    </swiper>
    <!-- para no loguedos -->
    <section v-else>
      <!-- frontend -->
      <h2 class="s-center">Proyectos Frontend</h2>
      <swiper
        class="swiper-container"
        :modules="modules"
        :slides-per-view="slide"
        :space-between="50"
        :pagination="{ clickable: true }">
        <swiper-slide
          v-for="proyecto in frontend"
          :key="proyecto.titulo"
          class="slide card-proyectos">
          <div class="">
            <img
              class="contenedor-proyecto_imagen_card"
              :src="proyecto.imagen"
              :alt="proyecto.nombre" />
          </div>
          <div class="card-proyecto__texto">
            <h3 class="s-center titulo">{{ proyecto.titulo }}</h3>
            <p class="s-center area">
              {{ proyecto.area }} {{ proyecto.subArea }}
            </p>
            <div
              v-html="proyecto.proyecto"
              class="proyecto__descripcion s-left"></div>
          </div>
          <!-- botones -->
          <div class="s-center">
            <Button
              class="boton-primario"
              label="Registrarse"
              v-on:click.prevent="Registrarse" />
          </div>
        </swiper-slide>
        ...
      </swiper>
      <br />

      <!-- backend -->
      <h2 class="s-center">Proyectos Backend</h2>
      <swiper
        class="swiper-container"
        :modules="modules"
        :slides-per-view="slide"
        :space-between="50"
        :pagination="{ clickable: true }">
        <swiper-slide
          v-for="proyecto in backend"
          :key="proyecto.titulo"
          class="slide card-proyectos">
          <div class="">
            <img
              class="contenedor-proyecto_imagen_card"
              :src="proyecto.imagen"
              :alt="proyecto.nombre" />
          </div>
          <div class="card-proyecto__texto">
            <h3 class="s-center titulo">{{ proyecto.titulo }}</h3>
            <p class="s-center area">
              {{ proyecto.area }} {{ proyecto.subArea }}
            </p>
            <div
              v-html="proyecto.proyecto"
              class="proyecto__descripcion s-left"></div>
          </div>
          <div class="s-center">
            <Button
              class="boton-primario"
              label="Registrarse"
              v-on:click.prevent="Registrarse" />
          </div>
        </swiper-slide>
        ...
      </swiper>
      <br />
      <!-- ux-->
      <h2 class="s-center">Proyectos UX</h2>
      <swiper
        class="swiper-container"
        :modules="modules"
        :slides-per-view="slide"
        :space-between="50"
        :pagination="{ clickable: true }">
        <swiper-slide
          v-for="proyecto in ux"
          :key="proyecto.titulo"
          class="slide card-proyectos">
          <div class="">
            <img
              class="contenedor-proyecto_imagen_card"
              :src="proyecto.imagen"
              :alt="proyecto.nombre" />
          </div>
          <div class="card-proyecto__texto">
            <h3 class="s-center titulo">{{ proyecto.titulo }}</h3>
            <p class="s-center area">
              {{ proyecto.area }} {{ proyecto.subArea }}
            </p>
            <div
              v-html="proyecto.proyecto"
              class="proyecto__descripcion s-left"></div>
          </div>
          <!-- botones -->
          <div class="s-center">
            <Button
              class="boton-primario"
              label="Registrarse"
              v-on:click.prevent="Registrarse" />
          </div>
        </swiper-slide>
        ...
      </swiper>
    </section>
  </div>
</template>

<script>
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

import { computed, ref } from "vue";
import { useStore } from "vuex";
import router from "../router";
import Card from "primevue/card";
import Button from "primevue/button";
export default {
  props: {
    isHome: false,
  },
  setup(props) {
    const store = useStore();

    let proyectos = computed(() => {
      return store.state.proyectos.todosLosProyectos;
    });

    let proyectosUsuario = computed(() => {
      return store.state.usuario.proyectosUsuario;
    });

    /* revisar si proyectos y proyectosUsuario son diferentes y retornarlos*/
    let proyectosNoUsuario = computed(() => {
      return proyectos.value.filter((proyecto) => {
        return !proyectosUsuario.value.find((proyectoUsuario) => {
          return proyectoUsuario.idProyecto === proyecto.id;
        });
      });
    });
    let frontend = proyectosNoUsuario.value.filter((ux) => {
      return ux.subArea === "Frontend";
    });
    let ux = proyectosNoUsuario.value.filter((ux) => {
      return ux.subArea === "UX";
    });
    let backend = proyectosNoUsuario.value.filter((ux) => {
      return ux.subArea === "Backend";
    });

    console.log(backend)

    let especializacionUsuario = ref("");
    let codigoUsuario = "";

    if (store.state.usuario.datosUsuario) {
      especializacionUsuario.value =
        store.state.usuario.datosUsuario.especializacion;
      codigoUsuario = store.state.usuario.datosUsuario.codigoDelCurso;
    }

    let curso = proyectos.value.find((codigo) => {
      return codigo.codigo == codigoUsuario;
    });

    let mostrarAreaProyectos = proyectosNoUsuario.value.filter((ux) => {
      return (
        especializacionUsuario.value.includes(ux.subArea) &&
        !ux.hasOwnProperty("codigo")
      );
    });

    let frontendProyectos = proyectosNoUsuario.value.filter((ux) => {
      return ux.subArea === "Frontend";
    });

    function requerimientoProyecto(idProyecto) {
      router.push({
        name: "proyectoId",
        params: {
          id: idProyecto,
        },
      });
    }

    function Registrarse() {
      router.push({ name: "registro" });
    }

    let tamaño = ref(0);
    let slide = ref(0);
    tamaño.value = window.screen.width;
    setInterval(() => {
      tamaño.value = window.screen.width;
      if (tamaño.value < 601) {
        slide.value = 1;
      } else if (tamaño.value < 1024) {
        slide.value = 2;
      } else {
        slide.value = 3;
      }
    }, 1000);
    return {
      /* variables */
      tamaño,
      slide,
      curso,
      /* computed */
      proyectos,
      mostrarAreaProyectos,
      proyectosUsuario,
      proyectosNoUsuario,
      frontend,
      backend,
      ux,
      /* funciones y props */
      requerimientoProyecto,
      Registrarse,
      frontendProyectos,
      props,
      modules: [Navigation, Pagination, Scrollbar, A11y],
    };
  },
  components: {
    Card,
    Button,
    Swiper,
    SwiperSlide,
  },
};
</script>
<style lang="scss" scoped>
@import "../sass/card.scss";
.proyecto__descripcion {
  width: 100%;
  padding-left: 8%;
  padding-right: 8%;
  margin-bottom: 5%;
  font-size: 14px;
  /* mostrar solo la mitad del contenido */
  overflow: hidden;
  text-overflow: ellipsis;
  /* cuando el texto es demasiado largo */
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /* cuantas lineas queremos que tenga */
  -webkit-box-orient: vertical;
}

.descripcion {
  height: 160px;
}
.curso button {
  background-color: #ffbb00;
  border-color: #ffbb00;
}
.curso h3 {
  color: #ffbb00;
}
</style>
